import React, { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PeopleIcon from '@mui/icons-material/People';
import NotificationsPausedOutlinedIcon from '@mui/icons-material/NotificationsPausedOutlined';
import useCanAccess from "../../hooks/useCanAccess";
import ActionCard from "../../components/Common/ActionCard";
import { brand, orange, cyan } from "../../components/AppTheme/themePrimitives";

export default function Administration() {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const { canAccessPage } = useCanAccess();

    const items = useMemo(() => {
        const itemList = [];
        if (canAccessPage('LOCATION_ADMINISTRATION')) {
            itemList.push({
                title: t("administration.actionItem.locationAdministration.title"),
                description: t("administration.actionItem.locationAdministration.description"),
                icon: <PeopleIcon />,
                accentColor: brand[400],
                onClick: () => navigate('/administration/location-administration'),
            });
        }

        if (canAccessPage('CLIENT_ALERTS')) {
            itemList.push({
                title: t("administration.actionItem.clientAlerts.title"),
                description: t("administration.actionItem.clientAlerts.description"),
                icon: <NotificationsActiveIcon />,
                accentColor: orange[400],
                onClick: () => navigate('/administration/client-alerts'),
            });
        }

        if (canAccessPage('IRRELEVANT_ENTRIES')) {
            itemList.push({
                title: t("administration.actionItem.ignoredEntries.title"),
                description: t("administration.actionItem.ignoredEntries.description"),
                icon: <NotificationsPausedOutlinedIcon />,
                accentColor: cyan[400],
                onClick: () => navigate('/administration/irrelevant-entries'),
            });
        }

        return itemList;
    }, [canAccessPage, t, navigate]);

    return (
        <Box sx={{ width: "100%", height: "100%", padding: 2 }}>
            <Typography variant="h4" gutterBottom>
                {t("navbar.administration")}
            </Typography>
            <Grid container spacing={2}>
                {items.map((item, index) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                        <ActionCard
                            title={item.title}
                            description={item.description}
                            icon={item.icon}
                            accentColor={item.accentColor}
                            onClick={item.onClick}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
